module.exports = __webpack_public_path__ + "static/media/more_horiz-black-18dp.2f922ffa.svg";